import { motion, useReducedMotion } from 'framer-motion'
import { Section } from '@shared/Section'
import { GlassCard, GlassCardContent } from '@/components/ui/glass-card'
import { features } from '@features/landing/content'
import { icons } from '@features/landing/icons'

export function Features() {
  const reduceMotion = useReducedMotion()

  return (
    <Section
      id="features"
      eyebrow="Platform"
      title="Everything between the conversation and the decision"
      description="Voice, analysis and activation in one place — so insight does not die in a slide deck."
    >
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, index) => {
          const Icon = icons[feature.icon]
          return (
            <motion.div
              key={feature.title}
              initial={reduceMotion ? false : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: (index % 3) * 0.08, ease: 'easeOut' }}
            >
              <GlassCard className="h-full" glowEffect={false}>
                <GlassCardContent className="flex h-full flex-col gap-3 p-6">
                  <Icon className="size-6 text-blue-700 dark:text-blue-300" aria-hidden />
                  <h3 className="text-lg font-semibold text-foreground">{feature.title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">{feature.body}</p>
                </GlassCardContent>
              </GlassCard>
            </motion.div>
          )
        })}
      </div>
    </Section>
  )
}
